export default {
  baseURL: state => state.baseURL
};